import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UpRequest = function (_NebulaModuleBase) {
    _inherits(UpRequest, _NebulaModuleBase);

    function UpRequest() {
        _classCallCheck(this, UpRequest);

        return _possibleConstructorReturn(this, (UpRequest.__proto__ || Object.getPrototypeOf(UpRequest)).apply(this, arguments));
    }

    _createClass(UpRequest, [{
        key: 'signRequest',
        value: function signRequest(options) {
            var _this2 = this;

            // 打点开始
            this.statPageEventData({
                tagName: 'net_' + options.url + '_start',
                timeStamp: +new Date()
            });
            var promiseResult = this.generatePromiseByFunctionWithParams('signRequestForSignRequest', options);
            promiseResult.then(function (ret) {
                if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000') {
                    // 打点结束
                    _this2.statPageEventData({
                        tagName: 'net_' + options.url + '_end',
                        timeStamp: +new Date()
                    });
                    // 更新track记录
                    _this2.updateTrackUrlStatus(options.url, options.method);
                }
            });
            return promiseResult;
        }
    }, {
        key: 'signRequestUniform',
        value: function signRequestUniform(options) {
            var _this3 = this;

            // 打点开始
            this.statPageEventData({
                tagName: 'net_' + options.url + '_start',
                timeStamp: +new Date()
            });
            var nativeFuncName = 'signRequestForSignRequest';
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                nativeFuncName = 'signRequestForIOS';
            }
            var promiseResult = this.generatePromiseByFunctionWithParams(nativeFuncName, options);
            promiseResult.then(function (ret) {
                if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000') {
                    // 打点结束
                    _this3.statPageEventData({
                        tagName: 'net_' + options.url + '_end',
                        timeStamp: +new Date()
                    });
                    // 更新track记录
                    _this3.updateTrackUrlStatus(options.url, options.method);
                }
            });
            return promiseResult;
        }
    }, {
        key: 'signRequestCache',
        value: function signRequestCache(options) {
            var _this4 = this;

            // 打点开始
            this.statPageEventData({
                tagName: 'net_' + options.url + '_start',
                timeStamp: +new Date()
            });
            var cacheResult = this.generatePromiseByFunctionWithParams('signRequestForSignRequest', options);
            var reqParams = options;
            reqParams.useCache = '0';
            reqParams.isUpdateCache = true;
            cacheResult.then(function (ret) {
                if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000') {
                    // 打点结束
                    _this4.statPageEventData({
                        tagName: 'net_' + options.url + '_end',
                        timeStamp: +new Date()
                    });
                    // 更新track记录
                    _this4.updateTrackUrlStatus(options.url, options.method);
                }
                _this4.signRequest(reqParams).then(function (signReqRet) {
                    reqParams.signRequestCallback(signReqRet);
                })['catch'](function (failResult) {
                    reqParams.signRequestCallback(failResult);
                });
            })['catch'](function (_) {
                _this4.signRequest(reqParams).then(function (signReqRet) {
                    reqParams.signRequestCallback(signReqRet);
                })['catch'](function (failResult) {
                    reqParams.signRequestCallback(failResult);
                });
            });
            return cacheResult;
        }
    }, {
        key: 'dynamicSignRequest',
        value: function dynamicSignRequest(options) {
            var _this5 = this;

            // 打点开始
            this.statPageEventData({
                tagName: 'net_' + options.url + '_start',
                timeStamp: +new Date()
            });
            var promiseResult = this.generatePromiseByFunctionWithParams('dynamicSignRequestForSignRequest', options);
            promiseResult.then(function (ret) {
                if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000') {
                    // 打点结束
                    _this5.statPageEventData({
                        tagName: 'net_' + options.url + '_end',
                        timeStamp: +new Date()
                    });
                    // 更新track记录
                    _this5.updateTrackUrlStatus(options.url, options.method);
                }
            });
            return promiseResult;
        }
    }, {
        key: 'getSpecialSign',
        value: function getSpecialSign(data) {
            return this.generatePromiseByFunctionWithParams('getSpecialSignForSignRequest', data);
        }
    }, {
        key: 'statPageEventData',
        value: function statPageEventData(params) {
            if (document.container.upTraceModule) {
                document.container.upTraceModule.statPageEventData(params)['catch'](function () {
                    return null;
                });
            }
        }
    }, {
        key: 'updateTrackUrlStatus',
        value: function updateTrackUrlStatus(url, method) {
            if (document.container.upTraceModule) {
                var observeUrls = document.container.upTraceModule.pageTrackObj.observeUrls || [];
                for (var i = 0; i < observeUrls.length; i++) {
                    if (observeUrls[i] && observeUrls[i].url === url && observeUrls[i].method === method) {
                        observeUrls[i].status = 'resolve';
                        break;
                    }
                }
            }
        }
    }]);

    return UpRequest;
}(NebulaModuleBase);